import { useService } from "@policoders/di";
import { BreadcrumbService } from "@policoders/ds";
import PageHeader from "@shared/components/page-header";
import { useEffect } from "react";

export const OverviewPage = () => {
  const breadcrumb = useService<BreadcrumbService>("BreadcrumbService");
  useEffect(() => {
    breadcrumb.set([{ label: "Início", value: "/overview" }]);
  }, [breadcrumb]);

  return (
    <>
      <PageHeader title="Overview" />

      <h2 className="h5">Módulos</h2>
      <hr className="mt-2" />
      <div className="card">
        <div className="card-body">
          <table className="table table-hover table-sm">
            <thead>
              <tr>
                <th>Nome</th>
                <th>Status</th>
                <th>Descrição</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>authentication</td>
                <td>Pendente revisão</td>
                <td>Precisa contemplar todo o fluxo de autenticação e provedores</td>
              </tr>
              <tr>
                <td>changeman</td>
                <td>Pendente revisão</td>
                <td></td>
              </tr>
              <tr>
                <td>chefs-assistant (Restaurante)</td>
                <td>OK</td>
                <td></td>
              </tr>
              <tr>
                <td>core-components</td>
                <td>Pendente revisão</td>
                <td></td>
              </tr>
              <tr>
                <td>health (Clínica)</td>
                <td>Pendente revisão</td>
                <td></td>
              </tr>
              <tr>
                <td>helpdesk (Suporte)</td>
                <td>Pendente revisão</td>
                <td></td>
              </tr>
              <tr>
                <td>main (Perfil/Gestão)</td>
                <td>Pendente revisão</td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="m-4"></div>

      <h2 className="h5">Components</h2>
      <hr className="mt-2" />
      <div className="card">
        <div className="card-body">
          <table className="table table-hover table-sm">
            <thead>
              <tr>
                <th>Nome</th>
                <th>Status</th>
                <th>Descrição</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>breadcrumb</td>
                <td>Pendente revisão</td>
                <td>Caminho da tela atual</td>
              </tr>
              <tr>
                <td>flash-message</td>
                <td>Pendente revisão</td>
                <td></td>
              </tr>
              <tr>
                <td>loader</td>
                <td>Pendente revisão</td>
                <td></td>
              </tr>
              <tr>
                <td>navbar</td>
                <td>Pendente revisão</td>
                <td></td>
              </tr>
              <tr>
                <td>modal</td>
                <td>Pendente revisão</td>
                <td>Modal principal</td>
              </tr>
              <tr>
                <td>modal (sub)</td>
                <td>Pendente revisão</td>
                <td>Modal de detalhes dentro do modal principal</td>
              </tr>
              <tr>
                <td>modal (alert)</td>
                <td>Pendente revisão</td>
                <td>Modal para notificações de erro e validações</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="m-4"></div>

      <h2 className="h5">Estrutura de pastas</h2>
      <hr className="mt-2" />
      <div className="card">
        <div className="card-body">
          <table className="table table-hover table-sm">
            <thead>
              <tr>
                <th>Pasta</th>
                <th>Descrição</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <i className="bi bi-folder2-open me-2"></i>
                  src
                </td>
                <td>Application</td>
              </tr>
              <tr>
                <td>
                  <i className="bi bi-folder2-open ms-3 me-2"></i>assets
                </td>
                <td>CSS e imagens globais</td>
              </tr>
              <tr>
                <td>
                  <i className="bi bi-folder2-open ms-3 me-2"></i>di
                </td>
                <td>Injeção de dependência</td>
              </tr>
              <tr>
                <td>
                  <i className="bi bi-folder2-open ms-3 me-2"></i>helpers
                </td>
                <td>Helpers: date, hash, json, logx</td>
              </tr>
              <tr>
                <td>
                  <i className="bi bi-folder2-open ms-3 me-2"></i>interfaces
                </td>
                <td>Pendente revisão</td>
              </tr>
              <tr>
                <td>
                  <i className="bi bi-folder2-open ms-3 me-2"></i>modules
                </td>
                <td>Módulos</td>
              </tr>
              <tr>
                <td>
                  <span className="ms-3"></span>
                  <i className="bi bi-folder2-open ms-3 me-2"></i>[module-name]
                </td>
                <td>Raiz do módulo</td>
              </tr>
              <tr>
                <td>
                  <span className="ms-3"></span>
                  <span className="ms-3"></span>
                  <i className="bi bi-folder2-open ms-3 me-2"></i>pages
                </td>
                <td>Componentens de páginas</td>
              </tr>
              <tr>
                <td>
                  <span className="ms-3"></span>
                  <span className="ms-3"></span>
                  <span className="ms-3"></span>
                  <i className="bi bi-folder2-open ms-3 me-2"></i>[page-name]
                </td>
                <td>Arquivos de html, css, hook, model, repository, store</td>
              </tr>
              <tr>
                <td>
                  <span className="ms-3"></span>
                  <span className="ms-3"></span>
                  <i className="bi bi-folder2-open ms-3 me-2"></i>services
                </td>
                <td>Pendente revisão</td>
              </tr>
              <tr>
                <td>
                  <span className="ms-3"></span>
                  <span className="ms-3"></span>
                  <i className="bi bi-folder2-open ms-3 me-2"></i>types
                </td>
                <td>Tipos compartilhados do módulo</td>
              </tr>
              <tr>
                <td>
                  <span className="ms-3"></span>
                  <span className="ms-3"></span>
                  <i className="bi bi-filetype-tsx ms-3 me-2"></i>layout.component.tsx
                </td>
                <td>Layout base, layout do módulo, navbar</td>
              </tr>
              <tr>
                <td>
                  <i className="bi bi-folder2-open ms-3 me-2"></i>router
                </td>
                <td>Rotas da aplicação</td>
              </tr>
              <tr>
                <td>
                  <i className="bi bi-folder2-open ms-3 me-2"></i>services
                </td>
                <td>Pendente revisão</td>
              </tr>
              <tr>
                <td>
                  <i className="bi bi-folder2-open ms-3 me-2"></i>settings
                </td>
                <td>Pendente revisão</td>
              </tr>
              <tr>
                <td>
                  <i className="bi bi-folder2-open ms-3 me-2"></i>shared
                </td>
                <td>
                  Pendente revisão
                  <br />
                  Components, base files (repository, store, model), dependency-injector,
                  sequence.repository
                </td>
              </tr>
              <tr>
                <td>
                  <i className="bi bi-folder2-open ms-3 me-2"></i>stores
                </td>
                <td>Pendente revisão</td>
              </tr>
              <tr>
                <td>
                  <i className="bi bi-folder2-open ms-3 me-2"></i>types
                </td>
                <td>Pendente revisão</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};
